import * as pkFBRReceiptEndorsementHandler from './pakistan/fbr/receiptEndorsementHandler';
import * as pkSRBReceiptEndorsementHandler from './pakistan/srb/receiptEndorsementHandler';
import * as keKRAReceiptEndorsementHandler from './kenya/kra/receiptEndorsementHandler';

const externalIntegrationUtils = require('../externalIntegrationUtils');
const logger = require('../../../logger/logger');

const externalEntities = externalIntegrationUtils.externalEntities;

export async function applyReceiptEndorsements(sale, receiptPrintPayload)
{
    try
    {
        if (sale.endorsements == null || sale.endorsements.length <= 0)
            return;

        for (const endorsement of sale.endorsements)
        {
            await applyReceiptEndorsement(sale, receiptPrintPayload, endorsement);
        }
    }
    catch (error)
    {
        logger.error(`Error occurred while applying sale endorsements. ${error}`, {}, error);
    }
}

async function applyReceiptEndorsement(sale, receiptPrintPayload, endorsement)
{
    try
    {
        const endorsementHandler = getReceiptEndorsementHandler(endorsement);

        if (endorsementHandler != null)
        {
            await endorsementHandler.applyReceiptEndorsement(sale, receiptPrintPayload, endorsement);
        }
    }
    catch (error)
    {
        logger.error(`Error occurred while applying sale endorsement with external entity '${endorsement.externalEntity}'. ${error}`, {}, error);
    }
}

function getReceiptEndorsementHandler(endorsement)
{
    switch (endorsement.externalEntity)
    {
        case externalEntities.saleEndorsement.pkFBR:
            return pkFBRReceiptEndorsementHandler;

        case externalEntities.saleEndorsement.pkSRB:
            return pkSRBReceiptEndorsementHandler;

        case externalEntities.saleEndorsement.keKRA:
            return keKRAReceiptEndorsementHandler;

        default:
            return null;
    }
}
